import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnSalesRatioContentSkeleton = () => (
  <Styles.Container>
    <Styles.DataSection>
      <Skeleton variant="text" width={120} height={20} />
      <Skeleton variant="text" width={80} height={32} />
      <Skeleton variant="text" width={160} height={20} />
    </Styles.DataSection>
    <Skeleton variant="rounded" width="100%" height={200} />
  </Styles.Container>
)

export default ReturnSalesRatioContentSkeleton
